import ThemeLocalization from "./locales/ThemeLocalization";
import DocLayout from "./DocLayout/index";

import ThemeProvider from "./theme";
import { ThemeSettings } from "./components/settings";
import { MSnackbarProvider } from "./components/snackbar";
import { MotionLazyContainer } from "./components/animate";
import { ChooseCodeLanguageProvider } from "./components/ChooseCodeLanguage/ChooseCodeLanguage";
import { AuthProvider } from "./auth/JwtContext";

function App() {
  // eslint-disable-next-line react-hooks/exhaustive-deps

  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <AuthProvider>
          {" "}
          <ThemeSettings>
            <ThemeLocalization>
              <MSnackbarProvider>
                <ChooseCodeLanguageProvider>
                  <DocLayout />
                </ChooseCodeLanguageProvider>
              </MSnackbarProvider>
            </ThemeLocalization>
          </ThemeSettings>
        </AuthProvider>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}

export default App;
